import kinsfolk from '../components/kinsfolk/kinsfolk'

export default {
  kinsfolk
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/family/resources/components.js